/**
 * Llamadas a la API de tokens personales y de administración de personas.
 */
import {
  tokenCreadoSchema,
  tokenSchema,
  usuarioSchema,
  type ActualizarUsuarioEntrada,
  type CrearTokenEntrada,
} from '@cdtec-backlog/contrato';
import { z } from 'zod';
import { solicitar } from '../../lib/api';

export const listarTokens = () => solicitar('/tokens', { esquema: z.array(tokenSchema) });

export const crearToken = (entrada: CrearTokenEntrada) =>
  solicitar('/tokens', { metodo: 'POST', cuerpo: entrada, esquema: tokenCreadoSchema });

export const revocarToken = (id: number) => solicitar(`/tokens/${id}`, { metodo: 'DELETE' });

export const cambiarPersona = (id: number, cambios: ActualizarUsuarioEntrada) =>
  solicitar(`/usuarios/${id}`, { metodo: 'PATCH', cuerpo: cambios, esquema: usuarioSchema });
